export const REPORTING_DEFAULT_PATH = 'api/reporting/powerbi';
export const REPORTING_WORKSPACES_PATH = `${REPORTING_DEFAULT_PATH}/workspaces`;
export const REPORTING_CONFIG_PATH = `${REPORTING_DEFAULT_PATH}/report-config`;

export interface ReportingApiResponseBody<T> {
  status: number;
  message?: string;
  body: T;
  error?: {
    errorMessage?: string;
    errorType?: string;
    offlineInfo?: string;
    stackTrace?: string | null;
  };
}
